import platform from '@/shared/utils/platform';
import requestDefault from '@/shared/utils/request';

export const isExsist = (): Promise<boolean> => requestDefault.postGate('f.password.tradeKey.isExsist');

// { loadingMessage: '设置中', successToast: '密码已设置' }
export const set = (vo: {
  area: string;
  deviceNo: string;
  orderId?: string;
  tradeKey: string;
}): Promise<boolean> => requestDefault.postGate('f.password.tradeKey.set', vo, {
  loadingMessage: '设置中',
});

export const getToken = (
  tradeKey: string,
  commodityId: string,
): Promise<{
  token: string;
}> => requestDefault.postGate(
  'f.password.tradeKey.gettoken',
  {
    tradeKey,
    commodityId,
    biz: 'LEND', // 提现操作
  },
  {
    loadingMessage: '验证中...',
  },
);

export const needBioAuth = (vo: {
  area: string;
  deviceNo: string;
}): Promise<boolean> => requestDefault.postGate('f.password.tradeKey.bioAuth', {
  ...vo,
  ...platform.currentPlatformType,
});

const TradeKeyApi = {
  isExsist,
  set,
  getToken,
  needBioAuth,
};

export default TradeKeyApi;
